import styled from "styled-components";

export const Container = styled.aside`
  width: 39.68%;
  height: 100%;
  position: relative;

  img {
    filter: brightness(30%);
    width: 100%;
    height: 100%;
    display: flex;

    object-fit: cover;
    object-position: center;
    position: absolute;
    z-index: -1;
    @media (max-width: 1200px) {
      visibility: hidden;
    }
  }

  .logo {
    height: 24.5%;
    @media (max-width: 1200px) {
      height: auto;
      text-align: left;
      padding-left: 10%;
    }

    svg {
      margin: 5.4rem 0 0 9rem;
      @media (max-width: 1200px) {
        max-width: 90%;
        fill: #000;
        margin: 3rem 0;
        path{
          fill: #000;
        }
      }
    }
  }
  @media (max-width: 1200px) {
    width: 90%;
    margin: auto auto auto 0;
    border: 0;
  }
`;

interface IOverlayProps {
  isHome: boolean;
  italinea?: boolean;
  criare?: boolean;
}

export const Overlay = styled.div<IOverlayProps>`
  padding: 7rem 0;
  width: 92%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  padding-left: 9rem;

  border: ${(props) =>
    !props.italinea && !props.criare ? "1px solid #ffffff" : "unset"};
  border-top-right-radius: ${(props) => (props.italinea ? "2rem" : "unset")};
  border-bottom-right-radius: ${(props) => (props.italinea ? "2rem" : "unset")};
  background: ${(props) =>
    props.italinea ? "#143C8A" : props.criare ? "black" : "unset"};
  border-left: unset;

  border-left: 0;

  h1,
  h2 {
    font-family: "Galano";
    font-style: normal;
    /* font-weight: ${(props) => (props.criare ? 800 : 600)}; */
    font-weight: 600;
    letter-spacing: ${(props) => (props.criare ? "-0.038rem" : "unset")};
    color: #ffffff;

    @media (max-width: 1200px) {
      color: ${(props) => (props.criare ? "#ffffff" : "#565656")};
    }
  }

  h1,
  h2 {
    margin: 0.35rem 0;
    @media (max-width: 1200px) {
      margin: 0;
      width: 100%;
      text-align: left;
    }
  }

  h1 {
    line-height: ${(props) => (props.isHome ? 5.3 : 3.7)}rem;
    font-size: ${(props) => (props.isHome ? 6.5 : 3.7)}rem;
    @media (max-width: 1200px) {
      font-size: 2.2rem;
      line-height: 2.2rem;
      margin-bottom: 1rem;
    }
  }

  .subscript {
    line-height: 4.1rem;
    font-size: 3rem;
    @media (max-width: 1200px) {
      font-size: 1.6rem;
      line-height: 2rem;
    }
  }

  .superscript {
    line-height: 4.1rem;
    font-size: 2.2rem;
    @media (max-width: 1200px) {
      margin-bottom: 1rem;
      font-size: 1.6rem;
      line-height: 1.6rem;
    }
  }
  @media (max-width: 1200px) {
    width: 100%;
    padding: 2.5em 2.5em 2.5em 10%;
    border: 1px solid #3c3c3c;
    border-left: 0;
  }

  .bar {
    width: 20%;
    height: 0.4rem;
    background: #ffffff;
    margin-top: 2.3rem;
  }
`;
